import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { initMenu } from "./utils/menus";
import 'font-awesome/css/font-awesome.min.css'
import guide from './guide'
Vue.prototype.$guide = guide
import ECharts from "echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/markLine";
import "echarts/lib/component/graphic";


Vue.prototype.$echarts = ECharts;
// Vue.prototype.$alert = MessageBox.alert
// Vue.prototype.$confirm = MessageBox.confirm
Vue.use(ElementUI);
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
	if (to.path == '/') {
		next();
	} else {
		if (window.sessionStorage.getItem("user")) {
			initMenu(router, store);
			next();
		} else {
			next('/?redirect=' + to.path);
		}
	}
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
